import React from "react";
import HeroSection from "../components/home/hero";
import MissionSection from "../components/home/mission";
import StatsSection from "../components/home/stats";
import SolutionSection from "../components/home/solution";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <main className="mx-auto">
        <HeroSection />
        <MissionSection />
        <StatsSection />
        <SolutionSection />
      </main>
    </div>
  );
}